import { render } from "./AddTaskCustomFieldPage.vue?vue&type=template&id=10474968&ts=true"
import script from "./AddTaskCustomFieldPage.vue?vue&type=script&lang=ts"
export * from "./AddTaskCustomFieldPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__